import { getTokenDefinition, } from "@bracket/chainography";
import { WEI, } from "@bracket/blocksmith";
import type { TokenIdentifier, WEIString, } from "@bracket/types";
import { Text as Tx, type TypeVariant, type SizeVariant, type ColorDeclaration, type ThemePalette, } from "@bracket/ui";
import type { FunctionComponent, } from "react";
import styled from "styled-components";



export declare type AssetValueProps = {
	value: WEIString|bigint;
	token: TokenIdentifier;
	variant?: TypeVariant;
	size?: SizeVariant;
	precision?: number;
	highlight?: string;
	color?: keyof ThemePalette | ColorDeclaration;
	bold?: boolean;
};



export const AssetValue: FunctionComponent<AssetValueProps> = ({
	bold,
	value,
	token,
	variant = "p",
	size = "md",
	color,
}) => {

	const numeric = WEI.fromSync(value, getTokenDefinition(token));
	return (
		<Brace>
			<Tx variant={variant} bold={bold} size={size} color={color}>{numeric.toDecimalString()}</Tx>
		</Brace>
	);

}


const Brace = styled.div`

`
